<div class="p-3 bg-dark bg-opacity-25 rounded-3" style="border: 1px solid rgba(255,255,255,0.07);">
    <h5 class="fw-bold text-white mb-2 fs-6">Change your Email Address</h5>
    <p class="text-muted small mb-3">Enter a new email address and your current password to update your account email.</p>
    <form (ngSubmit)="onSubmit()">
        <!-- New Email Field -->
        <div class="mb-3">
            <label for="newEmailInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">New Email Address</label>
            <input type="email" id="newEmailInput" class="form-control form-control-sm py-2" 
                [ngModel]="newEmail()" (ngModelChange)="newEmail.set($event)" name="newEmail" required>
        </div>

        <!-- Current Password Field -->
        <div class="mb-3">
            <label for="currentPasswordInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">Current Password</label>
            <input type="password" id="currentPasswordInput" class="form-control form-control-sm py-2" 
                [ngModel]="currentPassword()" (ngModelChange)="currentPassword.set($event)" name="currentPassword" required>
        </div>

        <!-- Buttons -->
        <div class="d-flex align-items-center gap-2 mt-3">
            <button type="button" class="btn btn-settings-cancel btn-sm px-3 py-1-5" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-settings-danger btn-sm px-3 py-1-5 fw-bold">Save</button>
        </div>
    </form>
</div>
